import ContentLoader from 'react-content-loader';

export function TokenCardSkeleton() {
  return (
    <ContentLoader speed={2} width={240} height={400} backgroundColor="#1E1F25" foregroundColor="black">
      <rect x="0" y="0" rx="3" ry="3" width="240" height="400" />
    </ContentLoader>
  );
}
